import { useQuery } from '@tanstack/react-query';

import { SearchBatchNameResponse } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchName: string;
}
export const searchBatchName = async (batchName: string): Promise<SearchBatchNameResponse> => {
  try {
    const result = await apiClient.batchesArchive.searchBatchName.query({ query: { name: batchName } });
    if (result.status !== 200) throw result.body;

    return result.body.data;
  } catch (error) {
    showErrorToast(error, 'Error searching the batch name!');
  }
};

export const useBatchesByName = ({ batchName }: HookProps) =>
  useQuery({
    queryKey: ['batches', batchName],
    queryFn: () => searchBatchName(batchName),
    placeholderData: [],
  });
